var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-4"},[_c('v-card-title',{staticClass:"text-subtitle-1 font-weight-bold justify-center"},[_vm._v(" Ingreso semanal VS promedio semanal 6 meses ")]),(_vm.loading)?[_c('v-skeleton-loader',{attrs:{"type":"image"}})]:(_vm.items.length && !_vm.loading)?_c('div',{staticClass:"d-flex justify-center"},[_c('apex-chart',{staticClass:"w-75",attrs:{"options":{
        chart: { type: 'rangeBar' },
        plotOptions: {
          bar: {
            horizontal: false,
            colors: {
              ranges: [
                {
                  from: -1000,
                  to: 0,
                  color: '#C71616',
                },
                {
                  from: 1,
                  to: 1000,
                  color: '#206689',
                },
              ],
              backgroundBarOpacity: 1,
              backgroundBarRadius: 0,
            },
          },
        },
        dataLabels: {
          enabled: true,
          offsetY: 0,
          style: {
            textAnchor: 'middle',
          },
          background: {
            enabled: true,
            foreColor: '#000000',
            padding: 4,
            borderRadius: 2,
            borderWidth: 1,
            opacity: 0.92,
          },
          formatter: function (val, opts) {
            return `${val}%`;
          },
        },
        tooltip: {
          y: {
            formatter: (val) => {
              return `<b>${val}%</b>`;
            },
          },
        },
        subtitle: {
          text: 'Variación',
          align: 'center',
          style: {
            fontSize: '12px',
            color: '#206689',
          },
        },
      },"series":_vm.items}})],1):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }